// constants

// action_component_subject
const SET_REFER_LOGIN = "SET_REFER_LOGIN";
const RESET_REFER_LOGIN = "RESET_REFER_LOGIN";

// reducers

const initialState = {};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_REFER_LOGIN:
			return { ...action.payload };

		case RESET_REFER_LOGIN:
			return {};

		default:
			return state;
	}
};

export default Reducer;

// actions

// const resolveAfter2Seconds = () => {
// 	return new Promise((resolve) => {
// 		setTimeout(() => {
// 			resolve("resolved");
// 		}, 2000);
// 	});
// };

// // action_component_subject
// export const decrementTestCounter = () => async (dispatch) => {
// 	const result = await resolveAfter2Seconds();
// 	console.log(result);
// 	dispatch({
// 		type: INCREMENT_TEST_COUNTER,
// 	});
// };

// action_component_subject, prefix set(not update),empty(not remove),hide,show
export const setReferLogin = (payload) => {
	return {
		type: SET_REFER_LOGIN,
		payload: payload,
	};
};

export const resetReferLogin = () => {
	return {
		type: RESET_REFER_LOGIN,
	};
};
